export default [

  {
    path: '/reports/services-summary',
    name: 'reports.services-summary',
    component: () => import('@/views/reports/servicessummary/ServicesSummaryReport.vue'),
    meta: {
      module: 'reports.services-summary',
      pageTitle: 'Services Summary Report',
      breadcrumb: [
        { text: 'Services Summary Report', active: true }
      ],
    }
  },

  {
    path: '/reports/geofenceTrip',
    name: 'reports.geofenceTrip',
    component: () => import('@/views/reports/geofenceTrip/GeofenceTripReport.vue'),
    meta: {
      module: 'reports.geofenceTrip',
      pageTitle: 'Geofence Trip Report',
      breadcrumb: [
        { text: 'Geofence Trip Report', active: true }
      ],
    }
  },

  {
    path: '/reports/geofence',
    name: 'reports.geofence',
    component: () => import('@/views/reports/Geofence/GeofenceReport'),
    meta: {
      module: 'reports.geofence',
      pageTitle: 'Geofence Report',
      breadcrumb: [
        { text: 'Geofence Report', active: true }
      ],
    }
  },

  {
    path: '/reports/rfid-container-dump',
    name: 'reports.rfidContainerDump',
    component: () => import('@/views/reports/RFIDContainerDump/RFIDContainerDumpReport.vue'),
    meta: {
      module: 'reports.rfidContainerDump',
      pageTitle: 'RFID Container Dump Report',
      breadcrumb: [
        { text: 'RFID Container Dump Report', active: true }
      ],
    }
  },

  {
    path: '/reports/reader-dump-plan',
    name: 'reports.readerDumpPlan',
    component: () => import('@/views/reports/ReaderDumpPlan/ReaderDumpPlanReport.vue'),
    meta: {
      module: 'reports.readerDumpPlan',
      pageTitle: 'Reader Plan Report',
      breadcrumb: [
        { text: 'Reader Plan Report', active: true }
      ],
    }
  },

  {
    path: '/reports/container-wash-rfid-plan',
    name: 'reports.containerWashRfidPlan',
    component: () => import('@/views/reports/ContainerWashRfidPlan/ContainerWashRfidPlanReport.vue'),
    meta: {
      module: 'reports.containerWashRfidPlan',
      pageTitle: 'Container Wash RFID Plan Report',
      breadcrumb: [
        { text: 'Container Wash RFID Plan Report', active: true }
      ],
    }
  },

  {
    path: '/reports/washer-plan',
    name: 'reports.washerPlan',
    component: () => import('@/views/reports/WasherPlan/WasherPlanReport.vue'),
    meta: {
      module: 'reports.washerPlan',
      pageTitle: 'Washing Plan Report',
      breadcrumb: [
        { text: 'Washing Plan Report', active: true }
      ],
    }
  },



  {
    path: '/reports/rfid-container-dump-service',
    name: 'reports.rfidContainerDumpService',
    component: () => import('@/views/reports/RFIDContainerDumpService/RFIDContainerDumpServiceReport.vue'),
    meta: {
      module: 'reports.rfidContainerDumpService',
      pageTitle: 'RFID Container Dump Service Report',
      breadcrumb: [
        { text: 'RFID Container Dump Service Report', active: true }
      ],
    }
  },

  {
    path: '/reports/container-pto',
    name: 'reports.PTO',
    component: () => import('@/views/reports/PTO/PTOReport.vue'),
    meta: {
      module: 'reports.PTO',
      pageTitle: 'Container Lift Report (PTO)',
    }
  },

  {
    path: '/reports/sweep-service',
    name: 'reports.WhsSweep',
    component: () => import('@/views/reports/SweeperService/SweeperServiceReport.vue'),
    meta: {
      module: 'reports.WhsSweep',
      pageTitle: 'Sweeper Service Report',
    }
  },

  {
    path: '/reports/container-wash-plan',
    name: 'reports.containerWashPlan',
    component: () => import('@/views/reports/ContainerWashPlan/ContainerWashPlan.vue'),
    meta: {
      module: 'reports.containerWashPlan',
      pageTitle: 'CONTAINER_WASH_PLAN_REPORT_TITLE',
      breadcrumb: [
        { text: 'CONTAINER_WASH_PLAN_REPORT_TITLE', active: true }
      ],
    }
  },

  {
    path: '/reports/fill-area',
    name: 'reports.fillAreas',
    component: () => import('@/views/reports/FillArea/FillAreaReport'),
    meta: {
      module: 'reports.fillAreas',
      pageTitle: 'Fill Area Report',
      breadcrumb: [
        { text: 'Fill Area Report', active: true }
      ],
    }
  },

  {
    path: '/reports/garden',
    name: 'reports.garden',
    component: () => import('@/views/reports/garden/GardenReport'),
    meta: {
      module: 'reports.garden',
      pageTitle: 'Garden Report',
      breadcrumb: [
        { text: 'Garden Plans', to: {name: 'plans.garden.list'} },
        { text: 'Garden Report', active: true }
      ],
    }
  },

  {
    path: '/reports/gGarden',
    name: 'reports.gGarden',
    component: () => import('@/views/reports/gGarden/GGardenReport'),
    meta: {
      module: 'reports.gGarden',
      pageTitle: 'Geofence Garden Report',
      breadcrumb: [
        { text: 'Geofence Garden Plans', to: {name: 'gplans.garden.index'} },
        { text: 'Geofence Garden Report', active: true }
      ],
    }
  },

  {
    path: '/reports/rain',
    name: 'reports.rain',
    component: () => import('@/views/reports/Rain/RainReport'),
    meta: {
      module: 'reports.rain',
      pageTitle: 'Rain Report',
      breadcrumb: [
        { text: 'Rain Plans', to: {name: 'plans.rain.list'} },
        { text: 'Rain Report', active: true }
      ],
    }
  },

  {
    path: '/reports/status',
    name: 'reports.status',
    component: () => import('@/views/reports/Status/StatusReport'),
    meta: {
      module: 'reports.status',
      pageTitle: 'Status Report',
      breadcrumb: [
        { text: 'Status Report', active: true }
      ],
    }
  },

  {
    path: '/reports/compactor',
    name: 'reports.compactor',

    component: () => import('@/views/reports/compactors/CompactorReport.vue'),
    meta: {
      module: 'reports.compactor',
      pageTitle: 'Compactor Report',
      breadcrumb: [
        { text: 'Compactor Report', active: true }
      ],
    }
  },

  {
    path: '/reports/trip',
    name: 'reports.trip',
    component: () => import('@/views/reports/trip/TripReport.vue'),
    meta: {
      module: 'reports.trip',
      pageTitle: 'Trip Report',
      breadcrumb: [
        { text: 'Trip Report', active: true }
      ],
    }
  },
  {
    path: '/reports/absence',
    name: 'reports.absence',

    component: () => import('@/views/reports/absence/AbsenceReport.vue'),
    meta: {
      module: 'reports.absence',
      pageTitle: 'Absence Report',
      breadcrumb: [
        { text: 'Absence Report', active: true }
      ],
    }
  },
  // {
  //   path: '/reports/sweepPlan',
  //   name: 'reports.sweepPlan',
  //
  //   component: () => import('@/views/reports/sweepPlan/SweepPlanReport.vue'),
  //   meta: {
  //     module: 'reports.sweepPlan',
  //     pageTitle: 'SweepPlan Report',
  //     breadcrumb: [
  //       { text: 'SweepPlan Report', active: true }
  //     ],
  //   }
  // },

  {
    path: '/reports/sweepPlan2',
    name: 'reports.sweepPlan',

    component: () => import('@/views/reports/sweeperPlan/SweepReport2Report.vue'),
    meta: {
      module: 'reports.sweepPlan',
      pageTitle: 'SweepPlan Report 2',
      breadcrumb: [
        { text: 'SweepPlan Report 2', active: true }
      ],
    }
  },



  {
    path: '/reports/containerPlan',
    name: 'reports.containerPlan',

    component: () => import('@/views/reports/containerPlan/ContainerPlanReport.vue'),
    meta: {
      module: 'reports.containerPlan',
      pageTitle: 'Container Plan Report',
      breadcrumb: [
        { text: 'Container Plan Report', active: true }
      ],
    }
  },
  {
    path: '/reports/sweep',
    name: 'reports.sweep',

    component: () => import('@/views/reports/sweep/SweepReport.vue'),
    meta: {
      module: 'reports.sweep',
      pageTitle: 'Sweep Report',
      breadcrumb: [
        { text: 'Sweep Report', active: true }
      ],
    }
  },


  {
    path: '/reports/containerService',
    name: 'reports.containerService',

    component: () => import('@/views/reports/containerService/ContainerServiceReport.vue'),
    meta: {
      module: 'reports.containerService',
      pageTitle: 'Container Service Report',
      breadcrumb: [
        { text: 'Container Service Report', active: true }
      ],
    }
  },

  {
    path: '/reports/history',
    name: 'reports.history',

    component: () => import('@/views/reports/history/HistoryReport.vue'),
    meta: {

      module: 'reports.history',
      pageTitle: 'History  Report',
      breadcrumb: [
        { text: 'History  Report', active: true }
      ],
    }
  },

  {
    path: '/reports/support-devices',
    name: 'reports.supportDevices',

    component: () => import('@/views/reports/support-devices/SupportDevices.vue'),
    meta: {
      module: 'reports.supportDevices',
      pageTitle: 'Support Devices  Report',
      breadcrumb: [
        { text: 'Support Devices  Report', active: true }
      ],
    }
  },

  {
    path: '/reports/forbidden-areas',
    name: 'reports.forbiddenAreas',
    component: () => import('@/views/reports/forbiddenAreas/ForbiddenAreasReport'),
    meta: {
      module: 'reports.forbiddenAreas',
      pageTitle: 'Forbidden Areas Report',
      breadcrumb: [
        { text: 'Forbidden Areas Report', active: true }
      ],
    }
  },

  {
    path: '/reports/landfill-areas',
    name: 'reports.landFillAreas',
    component: () => import('@/views/reports/landFillAreas/LandFillAreasReport'),
    meta: {
      module: 'reports.landFillAreas',
      pageTitle: 'Landfill Areas Report',
      breadcrumb: [
        { text: 'Landfill Areas Report', active: true }
      ],
    }
  },

  {
    path: '/reports/support-ompactor',
    name: 'reports.supportCompactor',
    component: () => import('@/views/reports/support-compactor/Report'),
    meta: {
      module:  'reports.supportCompactor',
      pageTitle: 'Support Compactor Report',
      breadcrumb: [
        { text: 'Support Compactor Report', active: true }
      ],
    }
  },

  {
    path: '/reports/drainage',
    name: 'reports.drainage',
    component: () => import('@/views/reports/drainage/DrainageReport'),
    meta: {
      module: 'reports.drainage',
      pageTitle: 'Drainage Plan Report',
      breadcrumb: [
        { text: 'Drainage Plan Report', active: true }
      ],
    }
  },
  {
    path: '/reports/rainPlan',
    name: 'reports.rainPlan',
    component: () => import('@/views/reports/rainPlan/RainPlanReport'),
    meta: {
      module: 'reports.rainPlan',
      pageTitle: 'Rain Plan Report',
      breadcrumb: [
        //{ text: 'Rain  Plan Report', active: true }
      ],
    }
  },

  {
    path: '/reports/network',
    name: 'reports.network',
    component: () => import('@/views/reports/network/NetworkReport'),
    meta: {
      module: 'reports.network',
      pageTitle: 'Network Plans Report',
      breadcrumb: [
        { text: 'Network Plans Report', active: true }
      ],
    }
  },
  {
    path: '/reports/utility',
    name: 'reports.utility',
    component: () => import('@/views/reports/utility/UtilityReport'),
    meta: {
      module: 'reports.utility',
      pageTitle: 'Utility Report',
      breadcrumb: [
        { text: 'Utility Report', active: true }
      ],
    }
  },

  {
    path: '/reports/distance',
    name: 'reports.distance',
    component: () => import('@/views/reports/distance/DistanceReport'),
    meta: {
      module: 'reports.distance',
      pageTitle: 'Distance Report',
      breadcrumb: [
        { text: 'Distance Report', active: true }
      ],
    }
  },

  {
    path: '/reports/pest',
    name: 'reports.pestControl',
    component: () => import('@/views/reports/pest/PestReport'),
    meta: {
      module: 'reports.pestControl',
      pageTitle: 'Pest Control Report',
      breadcrumb: [
        { text: 'Pest Control Report', active: true }
      ],
    }
  },
  {
    path: '/reports/support-center',
    name: 'reports.supportCenter',
    component: () => import('@/views/reports/supportCenter/SupportCenterReport'),
    meta: {
      module: 'reports.supportCenter',
      pageTitle: 'Support Center Report',
      breadcrumb: [
        { text: 'Support Center Report', active: true }
      ],
    }
  },

  {
    path: '/reports/stotalAbsencePerMonth',
    name: 'reports.totalAbsencePerMonth',
    component: () => import('@/views/reports/totalAbsencePerMonth/TotalAbsencePerMonthReport'),
    meta: {
      module: 'reports.totalAbsencePerMonth',
      pageTitle: 'Total Absence Monthly Report',
      breadcrumb: [
        { text: 'Total Absence Monthly Report', active: true }
      ],
    }
  },

  {
    path: '/reports/devicesAbsenceCountPerMonth',
    name: 'reports.devicesAbsenceCountPerMonth',
    component: () => import('@/views/reports/devicesAbsenceCountPerMonth/DevicesAbsenceCountPerMonth'),
    meta: {
      module: 'reports.devicesAbsenceCountPerMonth',
      pageTitle: 'Devices Absence Count PerMonth Report',
      breadcrumb: [
        { text: 'Devices Absence Count PerMonth Report', active: true }
      ],
    }
  },
  {
    path: '/reports/dumpPlanByStops',
    name: 'reports.dumpPlanByStops',
    component: () => import('@/views/reports/dumpPlanByStops/DumpPlanByStopsReport'),
    meta: {
      module: 'reports.dumpPlanByStops',
      pageTitle: 'Dump Plan By Stops Report',
      breadcrumb: [
        { text: 'Dump Plan By Stops Report', active: true }
      ],
    }
  },
  {
    path: '/reports/containerPestPlan',
    name: 'reports.containerPestPlan',
    component: () => import('@/views/reports/containerPestPlan/Report'),
    meta: {
      module: 'reports.containerPestPlan',
      pageTitle: 'Container Pest Plan Report',
      breadcrumb: [
        { text: 'Container Pest Plan Report', active: true }
      ],
    }
  },
  {
    path: '/reports/containerPestPlanSummary',
    name: 'reports.containerPestPlanSummary',
    component: () => import('@/views/reports/containerPestPlanSummary/Report'),
    meta: {
      module: 'reports.containerPestPlanSummary',
      pageTitle: 'Container Pest Plan Summary Report',
      breadcrumb: [
        { text: 'Container Pest Plan Summary Report', active: true }
      ],
    }
  },
  {
    path: '/reports/containerPestPlanComprehensive',
    name: 'reports.containerPestPlanComprehensive',
    component: () => import('@/views/reports/containerPestPlanComprehensive/Report'),
    meta: {
      module: 'reports.containerPestPlanComprehensive',
      pageTitle: 'Container Pest Plan Comprehensive Report',
      breadcrumb: [
        { text: 'Container Pest Plan Comprehensive Report', active: true }
      ],
    }
  },

  {
    path: '/reports/controlPest',
    name: 'reports.controlPest',
    component: () => import('@/views/reports/controlPest/PestReport'),
    meta: {
      module: 'reports.controlPest',
      pageTitle: 'Pest Report',
      breadcrumb: [
        { text: 'Control Pest Report', active: true }
      ],
    }
  },

  {
    path: '/reports/routeDistance',
    name: 'reports.routeDistance',
    component: () => import('@/views/reports/routeDistance/RouteDistanceReport'),
    meta: {
      module: 'reports.routeDistance',
      pageTitle: 'Work Time & Duration Report',
      breadcrumb: [
        { text: 'Work Time & Duration Report', active: true }
      ],
    }
  },

  {
    path: '/reports/containerAreaPlan',
    name: 'reports.containerAreaPlan',
    component: () => import('@/views/reports/ContainerAreaPlan/ContainerAreaPlanReport'),
    meta: {
      module: 'reports.containerAreaPlan',
      pageTitle: 'CONTAINER_AREA_PLAN_REPORT_TITLE',
      breadcrumb: [
        { text: 'CONTAINER_AREA_PLAN_REPORT_TITLE', active: true }
      ],
    }
  },

  {
    path: '/reports/totalAbsencePerDay',
    name: 'reports.absenceGenerated',
    component: () => import('@/views/reports/totalAbsencePerDay/TotalAbsencePerDayReport'),
    meta: {
      module: 'reports.absenceGenerated',
      pageTitle: 'Total Absence PerDay Report',
      breadcrumb: [
        { text: 'Total Absence PerDay Report', active: true }
      ],
    }
  },
  {
    path: '/reports/overspeed',
    name: 'reports.overspeed',
    component: () => import('@/views/reports/overspeed/OverspeedReport'),
    meta: {
      module: 'reports.overspeed',
      pageTitle: 'Overspeed Report',
      breadcrumb: [
        { text: 'Overspeed Report', active: true }
      ],
    }
  },
  {
    path: '/reports/nonLiftedContainers',
    name: 'reports.nonLiftedContainers',
    component: () => import('@/views/reports/non-liftedContainers/NonLiftedContainersReport'),
    meta: {
      module: 'reports.nonLiftedContainers',
      pageTitle: 'Non Lifted Containers Report',
      breadcrumb: [
        { text: 'Non Lifted Containers Report', active: true }
      ],
    }
  },
]
